export enum WaterSectionAdditionalTypeEnum {
  WaterDistributionVertical = 'water_distribution_vertical',
  WaterDistributionHorizontal = 'water_distribution_horizontal',
}
